<template>
  <div>
    <v-speed-dial
      fixed
      v-model="fab"
      bottom
      left
      direction="top"
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" dark fab>
          <v-icon v-if="fab"> mdi-close </v-icon>
          <listifyIconSvg
            v-else
            :width="43"
            class="mt-1 ml-n1"
            color="background"
          />
        </v-btn>
      </template>
      <v-tooltip v-for="link in links" :key="link.to" right color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            color="secondary"
            :to="link.to"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> {{ link.icon }} </v-icon>
          </v-btn>
        </template>
        <span> {{ link.name }} </span>
      </v-tooltip>

      <v-btn
        v-if="this.$dev"
        fab
        dark
        small
        color="secondary"
        @click="deleteCookies"
      >
        <v-icon color="primary">mdi-cookie-off-outline</v-icon>
      </v-btn>
      <v-tooltip v-if="this.$cookies.get('authToken')" right color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            color="secondary"
            @click="logout"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary">mdi-logout-variant</v-icon>
          </v-btn>
        </template>
        <span>Logout</span>
      </v-tooltip>
    </v-speed-dial>
  </div>
</template>

<script>
import listifyIconSvg from "./listifyIconSvg";
export default {
  name: "navigationFab",
  components: {
    listifyIconSvg,
  },
  data() {
    return {
      fab: false,
      links: [
        {
          icon: "mdi-home",
          to: "/",
          name: "Home",
        },
        {
          icon: "mdi-language-go",
          to: "/profile",
          name: "Listify",
        },
        {
          icon: "mdi-book-open-page-variant-outline",
          to: "/documentation",
          name: "Documentation",
        },
      ],
    };
  },
  methods: {
    deleteCookies: function () {
      this.$cookies.remove("authToken");
    },
    logout: function () {
      this.$cookies.remove("authToken");
      this.$globalState.topArtists = null;
      this.$globalState.userProfile = null;
      this.$globalState.userPlaylists = null;
      this.$globalState.listify = null;
      window.location = this.$siteUrl;
      let Notify = {
        duration: 4000,
        type: "success",
        headline: "Logout",
        message: "Successfully logged out!",
      };
      this.$globalState.addNotification(Notify);
    },
  },
};
</script>

<style scoped>
</style>